import React, { useCallback, useMemo } from 'react'
import * as R from 'ramda'
import { useTable } from 'hooks'
import { getColumns, getRowActions } from './model'
import { candidates } from 'orm'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentAccount } from 'ducks/auth'

const useCandidatesTableQueries = () => {
  const dispatch = useDispatch()

  const handleFetchCandidates = React.useCallback(
    ({ workspaceId, status }, { limit, offset, ordering, search }) => {
      dispatch(
        candidates.fetchStart({
          talent_assessment_workspace: workspaceId,
          status,
          limit,
          offset,
          ordering,
          search,
        }),
      )
    },
    [dispatch],
  )

  return {
    handleFetchCandidates,
  }
}

export const useInvitesTable = ({ search }) => {
  const dispatch = useDispatch()
  const columns = useMemo(() => getColumns(), [])
  const rowActions = useMemo(() => getRowActions(), [])

  const account = useSelector(getCurrentAccount)

  const status = React.useMemo(() => ['created', 'invited'], [])

  const workspaceId = account?.talent_assessment_workspace?.id

  const { handleFetchCandidates } = useCandidatesTableQueries()
  const data = useSelector(candidates.getModel)

  const { count, items, meta } = data ?? {}

  const fetchAction = React.useCallback(
    ({ limit, offset, ordering, search }) => {
      handleFetchCandidates(
        { workspaceId, status },
        { limit, offset, ordering, search },
      )
    },
    [workspaceId, status, handleFetchCandidates],
  )

  const handleSelection = React.useCallback(
    payload => {
      dispatch(candidates.setSelection(payload))
    },
    [dispatch],
  )

  const updateQueriesAction = useCallback(async () => {}, [])

  const stableSortingMap = useMemo(
    () => ({ name: 'name', progress: 'status' }),
    [],
  )
  const tableData = React.useMemo(() => R.pipe(R.values)(items), [items])

  const {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: {
        headers,
        model,
        isFetching,
        isAllRowsSelected,
        isSomeRowsSelected,
      },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
      table: { toggleAllRowsSelectedHandler },
    },
  } = useTable({
    columns,
    data: tableData,
    mapSortingPropToQueryParam: stableSortingMap,
    pageCount: count,
    search,
    fetchAction,
    updateQueriesAction,
    rowSelection: meta?.selected,
    onRowSelectionChange: handleSelection,
  })

  return {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: {
        headers,
        model,
        rowActions,
        isFetching,
        rowSelection: meta?.selected,
        isAllRowsSelected,
        isSomeRowsSelected,
      },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
      table: { toggleAllRowsSelectedHandler },
    },
  }
}
